import { ICustomerFullInfoState } from './customerFullInfoContext';
import { CustomerFullInfoActionTypes, TCustomerFullInfoAction } from './customerFullInfoActions';

export const customerFullInfoReducer = (
	state: ICustomerFullInfoState,
	action: TCustomerFullInfoAction,
): ICustomerFullInfoState => {
	switch (action.type) {
		case CustomerFullInfoActionTypes.CHANGE_CUSTOMER_FULL_INFO_VISIBLE_FORM:
			return {
				...state,
				customerFullInfoVisibleForm: action.payload.customerFullInfoVisibleForm,
			};
		case CustomerFullInfoActionTypes.SET_CUSTOMER_FOR_FULL_INFO:
			return {
				...state,
				customerForFullInfo: action.payload.customerForFullInfo,
			};
		case CustomerFullInfoActionTypes.SET_LOCALIZATION_GROUP:
			return {
				...state,
				selectedLocalizationGroup: action.payload.selectedLocalizationGroup,
			};
		case CustomerFullInfoActionTypes.SET_LOCALIZATION_LANGUAGE:
			return {
				...state,
				selectedLocalizationLanguage: action.payload.selectedLocalizationLanguage,
			};
		case CustomerFullInfoActionTypes.SET_LOCALIZATION_DATA:
			return {
				...state,
				localizationData: action.payload.localizationData,
			};
		case CustomerFullInfoActionTypes.SET_STYLE_DATA:
			return {
				...state,
				styleData: action.payload.styleData,
			};
		case CustomerFullInfoActionTypes.SET_STYLE_GROUP:
			return {
				...state,
				selectedStyleGroup: action.payload.selectedStyleGroup,
			};
		case CustomerFullInfoActionTypes.SET_STYLE_LANGUAGE:
			return {
				...state,
				selectedStyleLanguage: action.payload.selectedStyleLanguage,
			};
		case CustomerFullInfoActionTypes.SET_LATEST_SOFTWARE_UPDATE_DATA:
			return {
				...state,
				latestSoftwareUpdateData: action.payload.latestSoftwareUpdateData,
			};
		case CustomerFullInfoActionTypes.SET_BPA_DATA:
			return {
				...state,
				bpaData: action.payload.bpaData,
			};
		default:
			return state;
	}
};
